import { OrderedMap, Record } from 'immutable';
const HomepageOrganizationRecord = Record({
  knowledgeCategories: OrderedMap()
});
export default HomepageOrganizationRecord;